import Icon from '@ant-design/icons'
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

/**
 * 燃气图标 - 匹配 UI 风格（火苗 + 管道节点）
 */
const Svg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* 火苗轮廓 */}
    <path 
      d="M10 1.5C10 1.5 6 5.5 6 9.5C6 11.7091 7.79086 13.5 10 13.5C12.2091 13.5 14 11.7091 14 9.5C14 5.5 10 1.5 10 1.5Z" 
      stroke="url(#paint0_linear_gas)" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
    />
    {/* 内部装饰线 */}
    <path 
      d="M10 10.5C10.8284 10.5 11.5 9.82843 11.5 9C11.5 7.5 10 5.5 10 5.5" 
      stroke="url(#paint0_linear_gas)" 
      strokeWidth="1.2" 
      strokeLinecap="round" 
    />
    {/* 底部圆环/底座 */}
    <path 
      d="M4.5 16.5C4.5 15.3954 5.39543 14.5 6.5 14.5H13.5C14.6046 14.5 15.5 15.3954 15.5 16.5V17.5H4.5V16.5Z" 
      stroke="url(#paint0_linear_gas)" 
      strokeWidth="1.5" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
    />
    <defs>
      <linearGradient id="paint0_linear_gas" x1="4.5" y1="1.5" x2="15.5" y2="17.5" gradientUnits="userSpaceOnUse">
        <stop stopColor="#0CB6FF" />
        <stop offset="1" stopColor="#288EFF" />
      </linearGradient>
    </defs>
  </svg>
)

const GasIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={Svg} {...props} />
)

export default GasIcon